(function () {
  var api = window.NCProductWallFit || {};

  function initRoot(root) {
    if (!root || root.dataset.ncProductWallFitInitialized === "true") return;

    var trigger = root.querySelector("[data-nc-product-wall-fit-trigger]");
    var tooltip = root.querySelector("[data-nc-product-wall-fit-tooltip]");

    root.dataset.ncProductWallFitInitialized = "true";

    if (!trigger || !tooltip) return;

    root.ncProductWallFitToggleHandler = function () {
      var isExpanded = trigger.getAttribute("aria-expanded") === "true";

      trigger.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      tooltip.hidden = isExpanded;
    };

    trigger.addEventListener("click", root.ncProductWallFitToggleHandler);
  }

  function resetRoot(root) {
    if (!root) return;

    var trigger = root.querySelector("[data-nc-product-wall-fit-trigger]");
    var tooltip = root.querySelector("[data-nc-product-wall-fit-tooltip]");

    if (trigger) {
      if (root.ncProductWallFitToggleHandler) {
        trigger.removeEventListener("click", root.ncProductWallFitToggleHandler);
      }

      trigger.setAttribute("aria-expanded", "false");
    }

    if (tooltip) {
      tooltip.hidden = true;
    }

    delete root.ncProductWallFitToggleHandler;
    delete root.dataset.ncProductWallFitInitialized;
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-wall-fit]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-wall-fit]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-wall-fit]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-wall-fit]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCProductWallFit = api;

  if (!window.__ncProductWallFitEventsBound) {
    window.__ncProductWallFitEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCProductWallFit.initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      window.NCProductWallFit.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCProductWallFit.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCProductWallFit.initAll(document);
  }
})();
